import { css } from '@emotion/react';

/**
 * Shared table styling for the read-only Learner list and the editable
 * Add-or-remove-learners screens. Both render the same bordered table card
 * (name / email rows, centred pagination footer), so the layout lives here
 * to avoid the two components drifting apart.
 */
export const learnerTableStyles = {
  tableWrapper: css`
    border: 1px solid var(--cds-color-neutral-stroke-primary-weak);
    border-radius: var(--cds-border-radius-100);
    overflow: hidden;
  `,
  table: css`
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
    font-size: 14px;
    line-height: 20px;
  `,
  th: css`
    text-align: left;
    padding: var(--cds-spacing-150) var(--cds-spacing-200);
    background: var(--cds-color-neutral-background-primary-weak);
    border-bottom: 1px solid var(--cds-color-neutral-stroke-primary-weak);
  `,
  /* Pins the Name column width so it (and the Email column after it) stay put
     regardless of row content. Compose onto the Name `th`. */
  nameColumn: css`
    width: 40%;
  `,
  td: css`
    height: 72px;
    padding: 0 var(--cds-spacing-200);
    border-bottom: 1px solid var(--cds-color-neutral-stroke-primary-weak);
    color: var(--cds-color-neutral-primary);
    vertical-align: middle;
    overflow-wrap: break-word;
  `,
  emptyRow: css`
    padding: var(--cds-spacing-300) var(--cds-spacing-200);
    text-align: center;
    color: var(--cds-color-neutral-primary-weak);
  `,
  /* Pagination sits inside the bordered table card per design, separated
     from the last row by a subtle divider. */
  paginationRow: css`
    display: flex;
    justify-content: center;
    padding: var(--cds-spacing-150) var(--cds-spacing-200);
    border-top: 1px solid var(--cds-color-neutral-stroke-primary-weak);
    background: var(--cds-color-neutral-background-primary);
  `,
  actions: css`
    display: flex;
    align-items: center;
    gap: var(--cds-spacing-150);
  `,
};
